import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Username',
    field: 'userName',
    filter: 'text',
    searchable: true,
    navigate: true,
  },
  {
    title: 'First Name',
    field: 'firstName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Last Name',
    field: 'lastName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Role',
    field: 'userRolesNames',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Department',
    field: 'userDepartmentsNames',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Market Areas',
    field: 'userMarketAreasNames',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'License No',
    field: 'licenseNumber',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Email',
    field: 'email',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Phone',
    field: 'mobile',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Skill Set',
    field: 'skillSetCount',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Reporting Manager',
    field: 'userManagersNames',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'isActiveText',
    filter: 'text',
    searchable: true,
  },
];
